import { render, staticRenderFns } from "./c_upload_img.vue?vue&type=template&id=63e8fcdc&scoped=true"
import script from "./c_upload_img.vue?vue&type=script&lang=js"
export * from "./c_upload_img.vue?vue&type=script&lang=js"
import style0 from "./c_upload_img.vue?vue&type=style&index=0&id=63e8fcdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8fcdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e8fcdc')) {
      api.createRecord('63e8fcdc', component.options)
    } else {
      api.reload('63e8fcdc', component.options)
    }
    module.hot.accept("./c_upload_img.vue?vue&type=template&id=63e8fcdc&scoped=true", function () {
      api.rerender('63e8fcdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_upload_img.vue"
export default component.exports